module.exports = __webpack_public_path__ + "static/img/DoGreatWork_Mobile_11.28.65e7f15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/DoGreatWork_Mobile_11.28.svg
// module id = WV4s
// module chunks = 1